export default "__VITE_ASSET__DFL63pjw__"